module.exports = __webpack_public_path__ + "img/paytmMax.ef740677.png";